import { render, staticRenderFns } from "./DefaultAutoUpdateIndicator.vue?vue&type=template&id=25635084&scoped=true&"
import script from "./DefaultAutoUpdateIndicator.vue?vue&type=script&lang=js&"
export * from "./DefaultAutoUpdateIndicator.vue?vue&type=script&lang=js&"
import style0 from "./DefaultAutoUpdateIndicator.vue?vue&type=style&index=0&id=25635084&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25635084",
  null
  
)

export default component.exports